import { render, staticRenderFns } from "./roofPlacement.vue?vue&type=template&id=d6819708&scoped=true&"
import script from "./roofPlacement.vue?vue&type=script&lang=js&"
export * from "./roofPlacement.vue?vue&type=script&lang=js&"
import style0 from "./roofPlacement.vue?vue&type=style&index=0&id=d6819708&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6819708",
  null
  
)

export default component.exports